import styled from 'styled-components';
import { INNER_DOC_CARD_TEMPLATE_COLUMNS } from '../../../../app/pages/Documents/style';

export const DocumentsCard = styled.div`
  position: relative;
  background-color: ${(props) => props.theme.colors.white};
  box-shadow: 0px 4px 20px rgba(104, 104, 104, 0.1);
  border-radius: 4px;
  display: grid;
  align-items: center;
  grid-template-columns: ${INNER_DOC_CARD_TEMPLATE_COLUMNS};
  gap: 24px;
  height: 100px;

  > * {
    display: flex;
    align-items: center;
  }

  .file-icon {
    justify-content: center;
  }

  .title {
    line-height: 24px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
`;

export const MobileCard = styled.div`
  display: grid;
  grid-template-columns: 90px 1fr;
  row-gap: 16px;
  padding: 18px 0 25px;
  border-bottom: 1px solid #8b8b8b;

  .title {
    line-height: 24px;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  h5 {
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
    text-transform: uppercase;
    color: #646464;
  }

  *:nth-child(even) {
    justify-self: end;
    text-align: right;
  }

  svg {
    stroke: ${(props) => props.theme.colors.link};
  }
`;
